import { render, staticRenderFns } from "./ListLabourerAttendancePage.vue?vue&type=template&id=e8bcbc70&"
import script from "./ListLabourerAttendancePage.vue?vue&type=script&lang=js&"
export * from "./ListLabourerAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports